import TldlEpisodeCardFooter from './TldlEpisodeCardFooter';

export default TldlEpisodeCardFooter;
